var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('header',{ref:"header",staticClass:"vps-header",class:{'vps-header-extended':!_vm.sidebarOpen}},[_c('hamburger-menu',{attrs:{"open":_vm.sidebarOpen},on:{"toggle":_vm.toggleSidebar}}),_vm._t("search"),_vm._t("toolbar")],2)}
var staticRenderFns = []

export { render, staticRenderFns }